import { enableZoomOnHover } from '@/scripts/optional/magnify';

enableZoomOnHover(2);
